import React from 'react'
import Link from 'gatsby-link'
import { slide as MenuBurger } from 'react-burger-menu'
let styles = {
  bmBurgerButton: {
    position: 'fixed',
    width: '36px',
    height: '30px',
    left: '36px',
    top: '36px'
  },
  bmBurgerBars: {
    background: '#FCBF49'
  },
  bmCrossButton: {
    height: '24px',
    width: '24px'
  },
  bmCross: {
    background: '#bdc3c7'
  },
  bmMenu: {
    background: 'rgba(159, 200, 238, .9)',
    padding: '0.5em 1.5em 0',
    fontSize: '1em',
    display: 'block'
  },
  bmMorphShape: {
    fill: '#373a47'
  },
  bmItemList: {
    color: '#b8b7ad',
    padding: '0.8em',
  },
  bmItem: {
    color: 'white',
    textTransform: 'uppercase',
    padding: '10px 5px',
   // display: 'inline-block'
  },
  bmOverlay: {
    background: 'rgba(0, 0, 0, 0.1)'
  }
}

class Menu extends React.Component {
  showSettings(event) {
    event.preventDefault();
  }

  render() {
    return (
      <MenuBurger {...this.props} styles={ styles } pageWrapId={ "page-wrap" } isOpen={ false } onStateChange={ this.isMenuOpen } >
        <Link id="home" className="menu-item" to="/">Inicio</Link>
        <Link id="sucesos" className="menu-item" to="/sucesos">Sucesos</Link>
        <Link id="biografias" className="menu-item" to="/biografias">Biografías</Link>
        <Link id="recomendados" className="menu-item" to="/recomendados">Libros Recomendados</Link>
        <Link id="documentos" className="menu-item" to="/documentos">Documentos</Link>
        <Link id="contacto" className="menu-item" to="/contacto">Contacto</Link>
        {/*<Link id="blog" className="menu-item--small" to="/blog">Blog</Link>*/}
      </MenuBurger>
    )
  }

  isMenuOpen = (state) => {
    if(state.isOpen) {
      document.documentElement.style.overflow= "hidden";
      window.scrollTo(0,0);
    } else {
      document.documentElement.style.overflow= "auto"
    }
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/components/menu.js